import { useState } from 'react';
import { Button, Card, Form, Input, Space, Spin, Typography, message } from 'antd';
import { GlobalOutlined, LoginOutlined, UserOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

export default function HomePage({ user, loading, onPublic, onLogin, onContinue }) {
  const [submitting, setSubmitting] = useState(false);

  const submitLogin = async ({ username, password }) => {
    setSubmitting(true);
    try {
      await onLogin(username, password);
    } catch (error) {
      message.error(error.message || 'Login failed.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <div className="home-loading"><Spin size="large" /></div>;
  }

  return (
    <div className="home-entry">
      <div className="home-entry__intro">
        <Title className="text-gradient">Build a knowledge graph</Title>
        <Paragraph>
          Continue publicly on this browser, or sign in to keep graphs under
          your account and share them with other users.
        </Paragraph>
      </div>
      <div className="home-entry__choices">
        <Card className="home-choice-card" bordered={false}>
          <Space orientation="vertical" size={18}>
            <GlobalOutlined className="home-choice-icon" />
            <div>
              <Title level={3}>Public</Title>
              <Paragraph type="secondary">
                Use the existing browser-based workspace without signing in.
              </Paragraph>
            </div>
            <Button type="primary" size="large" onClick={onPublic}>
              Continue as public
            </Button>
          </Space>
        </Card>

        <Card className="home-choice-card" bordered={false}>
          <Space orientation="vertical" size={18} style={{ width: '100%' }}>
            <UserOutlined className="home-choice-icon" />
            <div>
              <Title level={3}>User login</Title>
            </div>
            {user?.authenticated ? (
              <Space orientation="vertical" style={{ width: '100%' }}>
                <Text>
                  Signed in as <Text strong>{user.display_name || user.username}</Text>
                </Text>
                <Button type="primary" size="large" onClick={onContinue}>
                  Continue to my workspace
                </Button>
              </Space>
            ) : (
              <Form layout="vertical" onFinish={submitLogin} style={{ width: '100%' }}>
                <Form.Item name="username" label="Username" rules={[{ required: true }]}>
                  <Input autoComplete="username" />
                </Form.Item>
                <Form.Item name="password" label="Password" rules={[{ required: true }]}>
                  <Input.Password autoComplete="current-password" />
                </Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  icon={<LoginOutlined />}
                  loading={submitting}
                  block
                >
                  Login
                </Button>
              </Form>
            )}
          </Space>
        </Card>
      </div>
    </div>
  );
}
